// Warehouse Denial Causes
// API related actions
export const FETCHING_WAREHOUSE_DENIAL_CAUSES_LIST = '@@toyota/FETCHING_WAREHOUSE_DENIAL_CAUSES_LIST';
export const FETCHED_WAREHOUSE_DENIAL_CAUSES_LIST = '@@toyota/FETCHED_WAREHOUSE_DENIAL_CAUSES_LIST';
export const FETCHED_WAREHOUSE_DENIAL_CAUSES_LIST_FAILED = '@@toyota/FETCHED_WAREHOUSE_DENIAL_CAUSES_LIST_FAILED';
export const FETCHING_WAREHOUSE_DENIAL_CAUSE = '@@toyota/FETCHING_WAREHOUSE_DENIAL_CAUSE';
export const FETCHED_WAREHOUSE_DENIAL_CAUSE = '@@toyota/FETCHED_WAREHOUSE_DENIAL_CAUSE';
export const FETCHED_WAREHOUSE_DENIAL_CAUSE_FAILED = '@@toyota/FETCHED_WAREHOUSE_DENIAL_CAUSE_FAILED';
export const ADDING_WAREHOUSE_DENIAL_CAUSE = '@@toyota/ADDING_WAREHOUSE_DENIAL_CAUSE';
export const ADDED_WAREHOUSE_DENIAL_CAUSE = '@@toyota/ADDED_WAREHOUSE_DENIAL_CAUSE';
export const ADDED_WAREHOUSE_DENIAL_CAUSE_FAILED = '@@toyota/ADDED_WAREHOUSE_DENIAL_CAUSE_FAILED';
export const SAVING_WAREHOUSE_DENIAL_CAUSE = '@@toyota/SAVING_WAREHOUSE_DENIAL_CAUSE';
export const SAVED_WAREHOUSE_DENIAL_CAUSE = '@@toyota/SAVED_WAREHOUSE_DENIAL_CAUSE';
export const SAVED_WAREHOUSE_DENIAL_CAUSE_FAILED = '@@toyota/SAVED_WAREHOUSE_DENIAL_CAUSE_FAILED';

// Complementary actions
export const FILTER_WAREHOUSE_DENIAL_CAUSES = '@@toyota/FILTER_WAREHOUSE_DENIAL_CAUSES';
export const CHANGE_WAREHOUSE_DENIAL_CAUSES_TEXT_FILTER = '@@toyota/CHANGE_WAREHOUSE_DENIAL_CAUSES_TEXT_FILTER';


// Shifts
// API related actions
export const FETCHING_SHIFTS_LIST = '@@toyota/FETCHING_SHIFTS_LIST';
export const FETCHED_SHIFTS_LIST = '@@toyota/FETCHED_SHIFTS_LIST';
export const FETCHED_SHIFTS_LIST_FAILED = '@@toyota/FETCHED_SHIFTS_LIST_FAILED';
export const FETCHING_SHIFT = '@@toyota/FETCHING_SHIFT';
export const FETCHED_SHIFT = '@@toyota/FETCHED_SHIFT';
export const FETCHED_SHIFT_FAILED = '@@toyota/FETCHED_SHIFT_FAILED';
export const ADDING_SHIFT = '@@toyota/ADDING_SHIFT';
export const ADDED_SHIFT = '@@toyota/ADDED_SHIFT';
export const ADDED_SHIFT_FAILED = '@@toyota/ADDED_SHIFT_FAILED';
export const SAVING_SHIFT = '@@toyota/SAVING_SHIFT';
export const SAVED_SHIFT = '@@toyota/SAVED_SHIFT';
export const SAVED_SHIFT_FAILED = '@@toyota/SAVED_SHIFT_FAILED';

// Complementary actions
export const FILTER_SHIFTS = '@@toyota/FILTER_SHIFTS';
export const CHANGE_SHIFTS_TEXT_FILTER = '@@toyota/CHANGE_SHIFTS_TEXT_FILTER';


// Zones
// API related actions
export const FETCHING_ZONES_LIST = '@@toyota/FETCHING_ZONES_LIST';
export const FETCHED_ZONES_LIST = '@@toyota/FETCHED_ZONES_LIST';
export const FETCHED_ZONES_LIST_FAILED = '@@toyota/FETCHED_ZONES_LIST_FAILED';
export const FETCHING_ZONE = '@@toyota/FETCHING_ZONE';
export const FETCHED_ZONE = '@@toyota/FETCHED_ZONE';
export const FETCHED_ZONE_FAILED = '@@toyota/FETCHED_ZONE_FAILED';
export const ADDING_ZONE = '@@toyota/ADDING_ZONE';
export const ADDED_ZONE = '@@toyota/ADDED_ZONE';
export const ADDED_ZONE_FAILED = '@@toyota/ADDED_ZONE_FAILED';
export const SAVING_ZONE = '@@toyota/SAVING_ZONE';
export const SAVED_ZONE = '@@toyota/SAVED_ZONE';
export const SAVED_ZONE_FAILED = '@@toyota/SAVED_ZONE_FAILED';

// Complementary actions
export const FILTER_ZONES = '@@toyota/FILTER_ZONES';
export const CHANGE_ZONES_TEXT_FILTER = '@@toyota/CHANGE_ZONES_TEXT_FILTER';
export const CHANGE_ASSIGNED_LOCATIONS = '@@toyota/CHANGE_ASSIGNED_LOCATIONS';


// Dashboard
// API related actions
export const FETCHING_NEXT_SHIFTS = '@@toyota/FETCHING_NEXT_SHIFTS';
export const FETCHED_NEXT_SHIFTS = '@@toyota/FETCHED_NEXT_SHIFTS';
export const FETCHED_NEXT_SHIFTS_FAILED = '@@toyota/FETCHED_NEXT_SHIFTS_FAILED';
export const FETCHING_PICKING_INDICATORS = '@@toyota/FETCHING_PICKING_INDICATORS';
export const FETCHED_PICKING_INDICATORS = '@@toyota/FETCHED_PICKING_INDICATORS';
export const FETCHED_PICKING_INDICATORS_FAILED = '@@toyota/FETCHED_PICKING_INDICATORS_FAILED';
export const PRINTING_PICKING_LABELS = '@@toyota/PRINTING_PICKING_LABELS';
export const PRINTED_PICKING_LABELS = '@@toyota/PRINTED_PICKING_LABELS';
export const PRINTED_PICKING_LABELS_FAILED = '@@toyota/PRINTED_PICKING_LABELS_FAILED';
export const GETTING_LABELS_TO_REPRINT = '@@toyota/GETTING_LABELS_TO_REPRINT';
export const GOT_LABELS_TO_REPRINT = '@@toyota/GOT_LABELS_TO_REPRINT';
export const GOT_LABELS_TO_REPRINT_FAILED = '@@toyota/GOT_LABELS_TO_REPRINT_FAILED';

// Complementary actions
export const CLEAR_SHIFTS_DATA = '@@toyota/CLEAR_SHIFTS_DATA';
export const DELETE_ALL_PICKING_LABELS = '@@toyota/DELETE_ALL_PICKING_LABELS';
export const DELETE_PICKING_LABELS_BY_ORDER_CODE = '@@toyota/DELETE_PICKING_LABELS_BY_ORDER_CODE';
export const EMPTY_PICKING_LABELS = '@@toyota/EMPTY_PICKING_LABELS';


// Manuals orders List
// API related actions
export const FETCHING_PICKING_DEALERS = '@@toyota/FETCHING_PICKING_DEALERS';
export const FETCHED_PICKING_DEALERS = '@@toyota/FETCHED_PICKING_DEALERS';
export const FETCHED_PICKING_DEALERS_FAILED = '@@toyota/FETCHED_PICKING_DEALERS_FAILED';
export const FETCHING_PICKING_AGENCIES = '@@toyota/FETCHING_PICKING_AGENCIES';
export const FETCHED_PICKING_AGENCIES = '@@toyota/FETCHED_PICKING_AGENCIES';
export const FETCHED_PICKING_AGENCIES_FAILED = '@@toyota/FETCHED_PICKING_AGENCIES_FAILED';
export const FETCHING_ORDERS = '@@toyota/FETCHING_ORDERS';
export const FETCHED_ORDERS = '@@toyota/FETCHED_ORDERS';
export const FETCHED_ORDERS_FAILED = '@@toyota/FETCHED_ORDERS_FAILED';
export const UPDATING_ORDERS = '@@toyota/UPDATING_ORDERS';
export const UPDATED_ORDERS = '@@toyota/UPDATED_ORDERS';
export const UPDATED_ORDERS_FAILED = '@@toyota/UPDATED_ORDERS_FAILED';

// Complementary actions
export const CLEAR_SPECIALS_ORDERS_DATA = '@@toyota/CLEAR_SPECIALS_ORDERS_DATA';
export const CHANGE_ORDERS_LIST_PAGE = '@@toyota/CHANGE_ORDERS_LIST_PAGE';
export const CHANGE_ORDERS_LIST_PAGE_SIZE = '@@toyota/CHANGE_ORDERS_LIST_PAGE_SIZE';
export const CHANGE_STATUS_FOR_SELECTED_ITEM = '@@toyota/CHANGE_STATUS_FOR_SELECTED_ITEM';

// Manuals orders Detail
// API related actions
export const FETCHING_ORDER_DETAIL = '@@toyota/FETCHING_ORDER_DETAIL';
export const FETCHED_ORDER_DETAIL = '@@toyota/FETCHED_ORDER_DETAIL';
export const FETCHED_ORDER_DETAIL_FAILED = '@@toyota/FETCHED_ORDER_DETAIL_FAILED';
export const PRINTING_LABELS_BY_ORDER_NUMBER_AND_SEQUENTIAL = '@@toyota/PRINTING_LABELS_BY_ORDER_NUMBER_AND_SEQUENTIAL';
export const PRINTED_LABELS_BY_ORDER_NUMBER_AND_SEQUENTIAL = '@@toyota/PRINTED_LABELS_BY_ORDER_NUMBER_AND_SEQUENTIAL';
export const PRINTED_LABELS_BY_ORDER_NUMBER_AND_SEQUENTIAL_FAILED =
'@@toyota/PRINTED_LABELS_BY_ORDER_NUMBER_AND_SEQUENTIAL_FAILED';
export const SAVING_ITEMS_SELECTED = '@@toyota/SAVING_ITEMS_SELECTED';
export const SAVED_ITEMS_SELECTED = '@@toyota/SAVED_ITEMS_SELECTED';
export const SAVED_ITEMS_SELECTED_FAILED = '@@toyota/SAVED_ITEMS_SELECTED_FAILED';

// Locations
// API related actions
export const FETCHING_LOCATIONS_LIST = '@@toyota/FETCHING_LOCATIONS_LIST';
export const FETCHED_LOCATIONS_LIST = '@@toyota/FETCHED_LOCATIONS_LIST';
export const FETCHED_LOCATIONS_LIST_FAILED = '@@toyota/FETCHED_LOCATIONS_LIST_FAILED';

// Complementary actions
export const FILTER_LOCATIONS = '@@toyota/FILTER_LOCATIONS';
export const CHANGE_LOCATIONS_TEXT_FILTER = '@@toyota/CHANGE_LOCATIONS_TEXT_FILTER';
export const CHANGE_LOCATIONS_LIST_PAGE = '@@toyota/CHANGE_LOCATIONS_LIST_PAGE';
export const CHANGE_LOCATIONS_LIST_PAGE_SIZE = '@@toyota/CHANGE_LOCATIONS_LIST_PAGE_SIZE';


// Scanning
// API related actions
export const FETCHING_AGENCIES_LIST = '@@toyota/FETCHING_AGENCIES_LIST';
export const FETCHED_AGENCIES_LIST = '@@toyota/FETCHED_AGENCIES_LIST';
export const FETCHED_AGENCIES_LIST_FAILED = '@@toyota/FETCHED_AGENCIES_LIST_FAILED';
export const FETCHING_AGENCY = '@@toyota/FETCHING_AGENCY';
export const FETCHED_AGENCY = '@@toyota/FETCHED_AGENCY';
export const FETCHED_AGENCY_FAILED = '@@toyota/FETCHED_AGENCY_FAILED';
export const FETCHING_REPLACEMENT_PART = '@@toyota/FETCHING_REPLACEMENT_PART';
export const FETCHED_REPLACEMENT_PART = '@@toyota/FETCHED_REPLACEMENT_PART';
export const FETCHED_REPLACEMENT_PART_FAILED = '@@toyota/FETCHED_REPLACEMENT_PART_FAILED';
export const SAVING_LINE_INFO = '@@toyota/SAVING_LINE_INFO';
export const SAVED_LINE_INFO = '@@toyota/SAVED_LINE_INFO';
export const SAVED_LINE_INFO_FAILED = '@@toyota/SAVED_LINE_INFO_FAILED';
export const FETCHING_PENDING_ITEMS_LIST = '@@toyota/FETCHING_PENDING_ITEMS_LIST';
export const FETCHED_PENDING_ITEMS_LIST = '@@toyota/FETCHED_PENDING_ITEMS_LIST';
export const FETCHED_PENDING_ITEMS_LIST_FAILED = '@@toyota/FETCHED_PENDING_ITEMS_LIST_FAILED';
export const FETCHING_REVIEWED_ITEMS_LIST = '@@toyota/FETCHING_REVIEWED_ITEMS_LIST';
export const FETCHED_REVIEWED_ITEMS_LIST = '@@toyota/FETCHED_REVIEWED_ITEMS_LIST';
export const FETCHED_REVIEWED_ITEMS_LIST_FAILED = '@@toyota/FETCHED_REVIEWED_ITEMS_LIST_FAILED';
export const FETCHING_SCANNING_WAREHOUSE_DENIAL_CAUSES_LIST = '@@toyota/FETCHING_SCANNING_WAREHOUSE_DENIAL_CAUSES_LIST';
export const FETCHED_SCANNING_WAREHOUSE_DENIAL_CAUSES_LIST = '@@toyota/FETCHED_SCANNING_WAREHOUSE_DENIAL_CAUSES_LIST';
export const FETCHED_SCANNING_WAREHOUSE_DENIAL_CAUSES_LIST_FAILED =
'@@toyota/FETCHED_SCANNING_WAREHOUSE_DENIAL_CAUSES_LIST_FAILED';
export const FETCHING_REPLACEMENT_PART_ORDER_REQUESTS_INFO = '@@toyota/FETCHING_REPLACEMENT_PART_ORDER_REQUESTS_INFO';
export const FETCHED_REPLACEMENT_PART_ORDER_REQUESTS_INFO = '@@toyota/FETCHED_REPLACEMENT_PART_ORDER_REQUESTS_INFO';
export const FETCHED_REPLACEMENT_PART_ORDER_REQUESTS_INFO_FAILED =
  '@@toyota/FETCHED_REPLACEMENT_PART_ORDER_REQUESTS_INFO_FAILED';
export const SAVING_REPLACEMENT_PART_WAREHOUSE_DENIAL_CAUSE = '@@toyota/SAVING_REPLACEMENT_PART_WAREHOUSE_DENIAL_CAUSE';
export const SAVED_REPLACEMENT_PART_WAREHOUSE_DENIAL_CAUSE = '@@toyota/SAVED_REPLACEMENT_PART_WAREHOUSE_DENIAL_CAUSE';
export const SAVED_REPLACEMENT_PART_WAREHOUSE_DENIAL_CAUSE_FAILED =
  '@@toyota/SAVED_REPLACEMENT_PART_WAREHOUSE_DENIAL_CAUSE_FAILED';
export const CREATING_SALE_INVOICE = '@@toyota/CREATING_SALE_INVOICE';
export const CREATED_SALE_INVOICE = '@@toyota/CREATED_SALE_INVOICE';
export const CREATED_SALE_INVOICE_FAILED = '@@toyota/CREATED_SALE_INVOICE_FAILED';

// Complementary actions
export const CLEAR_SCANNING_INFO = '@@toyota/CLEAR_SCANNING_INFO';
export const CLEAR_SCANNING_ITEMS = '@@toyota/CLEAR_SCANNING_ITEMS';
export const INVOICE_GENERATED = '@@toyota/INVOICE_GENERATED';
export const INVOICE_NOT_GENERATED = '@@toyota/INVOICE_NOT_GENERATED';

// Storage Pending
// API related actions
export const FETCHING_STORAGE_PENDING = '@@toyota/FETCHING_STORAGE_PENDING';
export const FETCHED_STORAGE_PENDING = '@@toyota/FETCHED_STORAGE_PENDING';
export const FETCHED_STORAGE_PENDING_FAILED = '@@toyota/FETCHED_STORAGE_PENDING_FAILED';

// Complementary actions
export const EMPTY_STORAGE_PENDING_CARS = '@@toyota/EMPTY_STORAGE_PENDING_CARS';
